import React, { SetStateAction, useState } from "react";
import {
  Button,
  ButtonGroup,
  Flex,
  Text,
  Card,
  Image,
  CardBody,
  Heading,
  Stack,
  CardFooter,
  Link
} from "@chakra-ui/react";
import LanguageTag from "./LanguageTag";
import DollyZoomPDF from "../documents/Computational_Dolly_Zoom_2023.pdf";
import {
  TiArrowRight,
} from "react-icons/ti";
import { FaGalacticSenate } from "react-icons/fa";


interface PortfolioPickProps {
  title: string;
  year: number | null;
  active: boolean;
  setActiveIdx: React.Dispatch<React.SetStateAction<number>>;
  idx: number;
}

export default function PortfolioPick(props: PortfolioPickProps) {
  const [hover, setHover] = useState<boolean>(false);
    return (
      <Button
        borderBottom={
          props.active ? "darkblue solid 2px" : "lightgrey solid 1px"
        }
        display="flex"
        justifyContent={props.active ? "flex-end" : "space-between"}
        alignItems="center"
        borderRadius={"0"}
        width="100%"
        background="transparent"
        p="0"
        m="0"
        _hover={{
          justifyContent: "flex-end",
          transition: "all 1s ease",
        }}
        disabled={props.active ? true : false}
        cursor={props.active ? "default" : "pointer"}
        onClick={(c) => props.setActiveIdx(props.idx)}
        onMouseOver={(c) => setHover(true)}
        onMouseOut={(c) => setHover(false)}
        transition="all 1s ease"
      >
        <Text
          variant={props.active ? "typeItalic" : "type"}
          textTransform={"none"}
          color={props.active ? "darkblue" : "mediumgrey"}
        >
          {props.title}
        </Text>
        {props.active || hover ? (
          <TiArrowRight color="darkblue" size="1rem" />
        ) : (
          <Text
            variant="type"
            textTransform={"none"}
            color={props.active ? "darkblue" : "mediumgrey"}
          >
            {props.year? props.year : ''}
          </Text>
        )}
      </Button>
    );
}